import React, {Component} from 'react';
import './SynthLabApp.css';
import SynthKitEngine from "./synthesizer/SynthKitEngine";
import {FormSelect, Container, Col, Row} from "react-bootstrap";
import EditorView from "./soundeditor/EditorView";
import MainNavBar from "./MainNavBar";
import PropTypes from "prop-types";

class SynthLabApp extends Component {
  static propTypes = {
    analyser: PropTypes.object,
    appTitle: PropTypes.string,
    audioContext: PropTypes.object,
    kitConfig: PropTypes.object,
    showVisualizer: PropTypes.bool,
    setKitConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      component: "Kick",
      zone: "head"
    }

    this.createADSREnvelope = this.createADSREnvelope.bind(this);
    this.createGain = this.createGain.bind(this);
    this.createBiquadFilter = this.createBiquadFilter.bind(this);
    this.createBufferSource = this.createBufferSource.bind(this);
    this.createConvolver = this.createConvolver.bind(this);
    this.createOscillator = this.createOscillator.bind(this);
    this.createWaveShaper = this.createWaveShaper.bind(this);
    this.deleteTool = this.deleteTool.bind(this);
    this.downloadKitConfigJson = this.downloadKitConfigJson.bind(this);
    this.playSynth = this.playSynth.bind(this);
    this.selectComponentAndZone = this.selectComponentAndZone.bind(this);
    this.setToolConfig = this.setToolConfig.bind(this);
    this.startLoop = this.startLoop.bind(this);
    this.stopLoop = this.stopLoop.bind(this);


    this.synthKit = new SynthKitEngine(this.props.audioContext, this.props.analyser);
    this.synthKit.loadKitConfig(this.props.kitConfig);
  }

  createADSREnvelope = () => {
    const newTool = {
      id: "adsrenvelope" + Date.now(),
      type: "adsrenvelope",
      attack: 0.2,
      decay: 0.1,
      sustain: 0.7,
      release: 1,
      connectsTo: []
    };
    this.setToolConfig(newTool.id, newTool);
  }

  createBiquadFilter = () => {
    const newBiquadFilter = {
      id: "biquadFilter" + Date.now(),
      type: "biquadFilter",
      filterType: "bandpass",
      frequency: 440,
      Q: 1,
      gain: 0,
      connectsTo: []
    };
    this.setToolConfig(newBiquadFilter.id, newBiquadFilter);
  }

  createBufferSource = () => {
    const newBufferSource = {
      id: "bufferSource" + Date.now(),
      type: "bufferSource",
      bufferSizeFactor: 2,
      duration: 1,
      connectsTo: []
    };
    this.setToolConfig(newBufferSource.id, newBufferSource);
  }

  createConvolver = () => {
    const newConvolver = {
      id: "convolver" + Date.now(),
      type: "convolver",
      buffer: "",
      gain: 1,
      connectsTo: []
    };
    this.setToolConfig(newConvolver.id, newConvolver);
  }

  createGain = () => {
    const newGain = {
      id: "gain" + Date.now(),
      type: "gain",
      gain: 1,
      settings: [
        {name: "exponentialRampToValueAtTime", gain: 0.001, time: 0.3}
      ],
      connectsTo: []
    };
    this.setToolConfig(newGain.id, newGain);
  }

  createOscillator = () => {
    const newOscillator = {
      id: "oscillator" + Date.now(),
      type: "oscillator",
      duration: 1,
      frequency: 440,
      settings: [
        {name: "exponentialRampToValueAtTime", frequency: 440, time: 1}
      ],
      connectsTo: []
    };
    this.setToolConfig(newOscillator.id, newOscillator);
  }

  createWaveShaper = () => {
    const newWaveShaper = {
      id: "waveShaper" + Date.now(),
      type: "waveShaper",
      curve: new Float32Array(44100),
      oversample: "none",
      connectsTo: []
    };
    this.setToolConfig(newWaveShaper.id, newWaveShaper);
  }

  deleteTool = (toolId) => {
    let kitConfig = Object.assign({}, this.props.kitConfig);
    kitConfig.config[this.state.component][this.state.zone].toolChain = kitConfig.config[this.state.component][this.state.zone].toolChain.filter(tool => {
      return tool.id !== toolId;
    });
    this.setState({
      kitConfig: kitConfig
    }, () => {
      this.synthKit.loadKitConfig(this.props.kitConfig);
    });
  }

  downloadKitConfigJson = () => {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(this.props.kitConfig, null, 2)], {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = "kitConfig.json";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  selectComponentAndZone(event) {
    const [component, zone] = event.target.value.split(" ");
    this.setState({
      component: component,
      zone: zone
    });
  }

  setToolConfig = (toolId, toolConfig) => {
    let isNew = true;
    let kitConfig = Object.assign({}, this.props.kitConfig);
    if(!kitConfig.config[this.state.component][this.state.zone].toolChain){
      kitConfig.config[this.state.component][this.state.zone].toolChain = [];
    }
    kitConfig.config[this.state.component][this.state.zone].toolChain = kitConfig.config[this.state.component][this.state.zone].toolChain.map(tool => {
      if(tool.id === toolId){
        isNew = false;
        return toolConfig;
      }
      return tool;
    });
    if(isNew){
      kitConfig.config[this.state.component][this.state.zone].toolChain.push(toolConfig);
    }
    this.setState({
      kitConfig: kitConfig
    }, () => {
      this.synthKit.loadKitConfig(this.props.kitConfig);
    });
    this.props.setKitConfig(kitConfig);
  }

  playSynth = () => {
    performance.mark("triggerZoneStart");
    this.synthKit.triggerZone(this.state.component, this.state.zone, 1, 0);
    performance.mark("triggerZoneEnd");
    performance.measure("triggerZone", "triggerZoneStart", "triggerZoneEnd");
    console.log(performance.getEntriesByName("triggerZone")[0].duration);
    performance.clearMeasures();
  }

  startLoop() {
    this.intervalId = setInterval(() => {
      this.synthKit.triggerZone(this.state.component, this.state.zone, 1, 0);
    }, 1000);
  }

  stopLoop() {
    clearInterval(this.intervalId);
  }

  render() {
    return (
        <Container className="SynthLabApp vh-100 mw-100 d-flex flex-column">
          <Row>
            <Col xl={12} className="SynthLabApp-header">
              <MainNavBar
                  analyser={this.props.analyser}
                  appTitle={this.props.appTitle}
                  createADSREnvelope={this.createADSREnvelope}
                  createBiquadFilter={this.createBiquadFilter}
                  createBufferSource={this.createBufferSource}
                  createConvolver={this.createConvolver}
                  createGain={this.createGain}
                  createOscillator={this.createOscillator}
                  createWaveShaper={this.createWaveShaper}
                  downloadKitConfigJson={this.downloadKitConfigJson}
                  playSynth={this.playSynth}
                  playSynthOld={this.playSynthOld}
                  showVisualizer={this.props.showVisualizer}
                  startLoop={this.startLoop}
                  stopLoop={this.stopLoop}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <FormSelect onChange={this.selectComponentAndZone}>
                {Object.keys(this.props.kitConfig.config).map((component) => (
                    Object.keys(this.props.kitConfig.config[component]).map((zone) => {
                      return <option key={component+zone} value={component+" "+zone}>{component} {zone}</option>
                    })
                ))
                }
              </FormSelect>
              <EditorView
                  component={this.state.component}
                  zone={this.state.zone}
                  toolChain={this.props.kitConfig.config[this.state.component][this.state.zone].toolChain}
                  deleteTool={this.deleteTool}
                  setToolConfig={this.setToolConfig}/>
            </Col>
          </Row>
        </Container>
    );
  }
}

export default SynthLabApp;